// extracted by mini-css-extract-plugin
module.exports = {"container":"messages_container__28hDT","icon":"messages_icon__1Tn8d"};